import { TSetTypeId as TSetTypeId$1, add as add$1, difference as difference$1, empty as empty$1, forEach as forEach$1, fromIterable as fromIterable$1, has as has$1, intersection as intersection$1, isEmpty as isEmpty$1, make as make$1, reduce as reduce$1, reduceSTM as reduceSTM$1, remove as remove$1, removeAll as removeAll$1, removeIf as removeIf$1, removeIfDiscard as removeIfDiscard$1, retainIf as retainIf$1, retainIfDiscard as retainIfDiscard$1, size as size$1, takeFirst as takeFirst$1, takeFirstSTM as takeFirstSTM$1, takeSome as takeSome$1, takeSomeSTM as takeSomeSTM$1, toChunk as toChunk$1, toHashSet as toHashSet$1, toReadonlyArray as toReadonlyArray$1, toReadonlySet as toReadonlySet$1, transform as transform$1, transformSTM as transformSTM$1, union as union$1 } from '../../internal/stm/tSet.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TSetTypeId = TSetTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Transactional set implemented on top of `TMap`.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Stores new element in the set.
 *
 * @since 2.0.0
 * @category mutations
 */
const add = add$1;

/**
 * Atomically transforms the set into the difference of itself and the
 * provided set.
 *
 * @since 2.0.0
 * @category mutations
 */
const difference = difference$1;

/**
 * Makes an empty `TSet`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Atomically performs transactional-effect for each element in set.
 *
 * @since 2.0.0
 * @category elements
 */
const forEach = forEach$1;

/**
 * Makes a new `TSet` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Tests whether or not set contains an element.
 *
 * @since 2.0.0
 * @category elements
 */
const has = has$1;

/**
 * Atomically transforms the set into the intersection of itself and the
 * provided set.
 *
 * @since 2.0.0
 * @category mutations
 */
const intersection = intersection$1;

/**
 * Tests if the set is empty or not
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = isEmpty$1;

/**
 * Makes a new `TSet` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Atomically folds using a pure function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Atomically folds using a transactional function.
 *
 * @since 2.0.0
 * @category folding
 */
const reduceSTM = reduceSTM$1;

/**
 * Removes a single element from the set.
 *
 * @since 2.0.0
 * @category mutations
 */
const remove = remove$1;

/**
 * Removes elements from the set.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeAll = removeAll$1;

/**
 * Removes bindings matching predicate and returns the removed entries.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeIf = removeIf$1;

/**
 * Removes elements matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
const removeIfDiscard = removeIfDiscard$1;

/**
 * Retains bindings matching predicate and returns removed bindings.
 *
 * @since 2.0.0
 * @category mutations
 */
const retainIf = retainIf$1;

/**
 * Retains elements matching predicate.
 *
 * @since 2.0.0
 * @category mutations
 */
const retainIfDiscard = retainIfDiscard$1;

/**
 * Returns the set's cardinality.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeFirst = takeFirst$1;

/**
 * Takes the first matching value, or retries until there is one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeFirstSTM = takeFirstSTM$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeSome = takeSome$1;

/**
 * Takes all matching values, or retries until there is at least one.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeSomeSTM = takeSomeSTM$1;

/**
 * Collects all elements into a `Chunk`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toChunk = toChunk$1;

/**
 * Collects all elements into a `HashSet`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toHashSet = toHashSet$1;

/**
 * Collects all elements into a `ReadonlyArray`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toReadonlyArray = toReadonlyArray$1;

/**
 * Collects all elements into a `ReadonlySet`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toReadonlySet = toReadonlySet$1;

/**
 * Atomically updates all elements using a pure function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transform = transform$1;

/**
 * Atomically updates all elements using a transactional function.
 *
 * @since 2.0.0
 * @category mutations
 */
const transformSTM = transformSTM$1;

/**
 * Atomically transforms the set into the union of itself and the provided
 * set.
 *
 * @since 2.0.0
 * @category mutations
 */
const union = union$1;

export { TSetTypeId, add, difference, empty, forEach, fromIterable, has, intersection, isEmpty, make, reduce, reduceSTM, remove, removeAll, removeIf, removeIfDiscard, retainIf, retainIfDiscard, size, takeFirst, takeFirstSTM, takeSome, takeSomeSTM, toChunk, toHashSet, toReadonlyArray, toReadonlySet, transform, transformSTM, union };
